import { connect } from 'react-redux';
import { Segment, VerticalSpacer } from '../../core/core';
import styles from '../../SCSS/GalleryStyleDashboard.module.scss';
import segmentStyles from '../../SCSS/Segment.module.scss';
import utilityStyles from '../../SCSS/common/utilityStyles.module.scss';
import { useHistory } from 'react-router-dom';

type Props = {
  userProfile?: {
    keyRing: Array<string>;
  };
  categories: Record<string, unknown>;
};

type CategoryProps = {
  category: {
    representativeImage: string;
    onClickUrl: string;
    title: string;
  };
};

const GalleryCard = ({ category }: CategoryProps) => {
  const history = useHistory();
  return (
    <div className={styles.galleryCard} key={category.title} onClick={() => history.push(category.onClickUrl)}>
      {category.representativeImage && (
        <img className={styles.cardImage} src={category.representativeImage} alt={category.title} />
      )}
      {category.title}
    </div>
  );
};

const GalleryStyleDashboard = (props: Props) => {
  const categoryKeys = Object.keys(props.categories);
  return (
    <div className={styles.gallery}>
      <VerticalSpacer ems={2} />
      <Segment className={utilityStyles.line}>
        <div className={styles.titleBar}>
          <div className={segmentStyles.moduleTitle}>Gallery of Student Creations</div>
        </div>
      </Segment>
      <div className={styles.galleryCards}>
        {categoryKeys.map((category, index) =>
          props.categories[category].requiredKeys ? (
            props.categories[category].requiredKeys.reduce(
              (acc, key) => (!acc ? false : props.userProfile.keyRing.includes(key)),
              true,
            ) && <GalleryCard key={index} category={props.categories[category]} />
          ) : (
            <GalleryCard key={index} category={props.categories[category]} />
          ),
        )}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  userProfile: state.user.userProfile,
});

export default connect(mapStateToProps, null)(GalleryStyleDashboard);
